import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(
    private router: Router,
    private http: HttpClient
  ) {
    const userString = localStorage.getItem('user');

  let user = null;
  try {
    user = userString ? JSON.parse(userString) : null;
  } catch (e) {
    console.warn('Invalid stored user, clearing...', e);
    localStorage.removeItem('user');
  }

  this.currentUserSubject = new BehaviorSubject<any>(user);
  this.currentUser = this.currentUserSubject.asObservable();
}

  public get currentUserValue() {
    return this.currentUserSubject.value;
  }
  get accessToken(): string | null {
    return localStorage.getItem('accessToken');
  }
  get isLoggedIn(): boolean {
    return !!localStorage.getItem('accessToken') && !!localStorage.getItem('user');
  }

  login(email: string, password: string): Observable<any> {
    return this.http.post(`${environment.apiUrl}auth/signin`, { 
      email, 
      password 
    });
  }
  getUserId(): string | null {
    const user = this.currentUserValue;
    return user?.id || null;
  }
  register(userData: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}auth/signup`, userData);
  }

  logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
     localStorage.removeItem('selectedWarehouseId');
    this.currentUserSubject.next(null); 
    this.router.navigate(['/auth/login']);
  }
    // Warehouse ID management
  setSelectedWarehouseId(warehouseId: string): void {
    localStorage.setItem('selectedWarehouseId', warehouseId);
  }

  getSelectedWarehouseId(): string | null {
    return localStorage.getItem('selectedWarehouseId');
  }

  clearSelectedWarehouseId(): void {
    localStorage.removeItem('selectedWarehouseId');
  }


}